import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-10/task-03";

const task: Slide = {
  titleHtml: `Is a volume of 1000 m<sup>3</sup> suitable for a symphonic orchestra? There can be more than one answer.`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
